export type EventRouter = {
  parse: (topic: string) => EventRoute;
  topic: string;
};

export type EventRoute = {
  topic: string;
  get: (binding: string) => string | undefined;
  all: () => Record<string, string>;
};

export const useEventRoute = (channel: string, route: string): EventRouter => {
  const fullRoute = [channel, route].join('.');

  const parts = fullRoute.split('.').map((part) => {
    if (part.startsWith('{{') && part.endsWith('}}')) {
      return {
        type: 'binding',
        value: part.slice(2, -2),
      } as const;
    }

    if (part === '*' || part === '#') {
      return {
        type: 'wildcard',
        value: part,
      } as const;
    }

    return {
      type: 'literal',
      value: part,
    } as const;
  });

  return {
    parse: (topic) => {
      const bindings: Record<string, string> = {};

      const topicParts = topic.split('.');
      parts.forEach((part, index) => {
        if (part.type === 'binding') {
          bindings[part.value] = topicParts[index]?.slice(1, -1);
        }
      });

      return {
        topic: topic.substring(channel.length + 1),
        get: (binding) => bindings[binding],
        all: () => bindings,
      };
    },
    topic: parts
      .map((part) => {
        if (part.type === 'binding') {
          return '*';
        }

        return part.value;
      })
      .join('.'),
  };
};
